import { compileChecks } from "@mx/gpl-common";
import { cs } from "../../core/classSet";
import styles from "./Chevron.module.css";

// Chevron size relates to the font size. They should be 2px smaller than the font.
// The ChevronSize "primary" goes with fontPrimary and "secondary" with fontSecondary.
export type ChevronSize = "primary" | "secondary" | "compact" | "regular";

export interface ChevronProps {
  direction?:
    | "up"
    | "rotateUp"
    | "right"
    | "rotateRight"
    | "down"
    | "rotateDown"
    | "left"
    | "rotateLeft";
  size?: ChevronSize;
}

export default function Chevron({ size = "regular", direction = "right" }: ChevronProps) {
  const directionClassName = styles[direction];
  const fillColor = "currentColor";
  const className = cs(styles.root, directionClassName);

  switch (size) {
    case "compact":
      return (
        <svg className={className} viewBox="0 0 8 5" width="8" height="5">
          <path
            d="M0 4.051L3.889 0l3.889 4.051-.734.764L3.89 1.528.733 4.815 0 4.05z"
            fill={fillColor}
            stroke="none"
          />
        </svg>
      );
    case "primary":
      return (
        <svg className={className} viewBox="0 0 12 7" width="12" height="7">
          <path
            d="M10.994 6.369a.875.875 0 01-1.238 0L6 2.612 2.244 6.37A.875.875 0 111.006 5.13L5.381.756a.875.875 0 011.238 0l4.375 4.375a.875.875 0 010 1.238z"
            fill={fillColor}
            stroke="none"
          />
        </svg>
      );
    case "secondary":
      return (
        <svg className={className} viewBox="0 0 8 5" width="8" height="5">
          <path
            d="M7.567 4.692a.625.625 0 01-.884 0L4 2.009 1.317 4.692a.625.625 0 11-.884-.884L3.558.683a.625.625 0 01.884 0l3.125 3.125a.625.625 0 010 .884z"
            fill={fillColor}
            stroke="none"
          />
        </svg>
      );
    default:
      compileChecks.switchDefault(size).exhaustive<"regular">();
      return (
        <svg className={className} viewBox="0 0 12 7" width="12" height="7">
          <path
            d="M5.4.3c.3-.4.9-.4 1.2 0l5.1 5a.9.9 0 1 1-1.2 1.3L6 2.1 1.5 6.6A.9.9 0 1 1 .3 5.4l5-5.1Z"
            fill={fillColor}
            stroke="none"
          />
        </svg>
      );
  }
}
